// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aHYgF","content":"styles_content__Bzo8O","row":"styles_row__2p-Sf","footer":"styles_footer__21Kjh","phraseLength":"styles_phraseLength__2xDnH"};